import { render, staticRenderFns } from "./DeleteResolutionNotifications.vue?vue&type=template&id=6198e384&"
import script from "./DeleteResolutionNotifications.vue?vue&type=script&lang=js&"
export * from "./DeleteResolutionNotifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports